module.exports = __webpack_public_path__ + "static/media/google-store-download.088a7346.png";